// Utility to format decimal hours as '2h 33min' or '45min'
export function formatHoursMinutes(decimalHours, include_seconds = false) {
  // Accept null/undefined/NaN and treat as zero
  if (decimalHours == null || isNaN(decimalHours)) {
    return include_seconds ? '00:00:00' : '00:00';
  }

  // Use total seconds to avoid rounding inconsistencies
  const totalSeconds = Math.round(decimalHours * 3600);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const hoursStr = String(hours).padStart(2, '0');
  const minutesStr = String(minutes).padStart(2, '0');
  const secondsStr = String(seconds).padStart(2, '0');

  if (include_seconds) {
    return `${hoursStr}:${minutesStr}:${secondsStr}`;
  }

  return `${hoursStr}:${minutesStr}`;
}
